module.exports = __webpack_public_path__ + "img/card.ead10142.svg";